// Solicited links already sent via SMS/email still use the legacy `company_id` param.
export const normalizeCompanyIdParam = <T extends object>(
  search: T & { companyId?: string; company_id?: string }
): T => {
  const { company_id: legacyCompanyId, ...rest } = search;
  const companyId = rest.companyId || legacyCompanyId;
  return (companyId ? { ...rest, companyId } : rest) as unknown as T;
};
